import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import LoginModalContainer from "../../../components/login/login-modal-container";
import LoginModal from "../../../components/general/login-modal";
import { Button, Typography } from "@vapor/react-material";
import { SuccessIcon } from "../../sso/connect-account-feedback/success/styled";

function ForgotPasswordSuccess() {
    const intl = useIntl();
    const navigate = useNavigate();

    return (
        <LoginModalContainer>
            <LoginModal
                title={
                    <>
                        <SuccessIcon>
                            <FontAwesomeIcon icon={faCheckCircle} />
                        </SuccessIcon>
                        <div style={{ textAlign: "center" }}>
                            <FormattedMessage id="forgot-password.title-success" />
                        </div>
                    </>
                }
            >
                <Typography sx={{ mb: 3 }} align="center" color="primary.textSubduedColor" variant="bodyLarge">
                    <FormattedMessage id="v-forgot-password-success" />
                </Typography>
                <Button onClick={() => navigate("/")} variant="contained">
                    {intl.formatMessage({
                        id: "forgot-password.button-continue"
                    })}
                </Button>
            </LoginModal>
        </LoginModalContainer>
    );
}

export default ForgotPasswordSuccess;
